import { jsx as e } from "react/jsx-runtime";
//#region src/IconAccessibilityArcomAudioDescription.tsx
function t(t) {
	return /* @__PURE__ */ e("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 39 24",
		...t,
		children: /* @__PURE__ */ e("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M34.883 5h.438A11.4 11.4 0 0 1 38 12.325c0 2.396-.763 4.723-2.124 6.622h-1.628a10.38 10.38 0 0 0 2.396-6.622c0-2.748-1.105-5.394-3.02-7.325zM11.659 19h3.02V5.01h-3.773L1 19h4.435L6.6 17.15h5.06zm-3.163-4.765h3.181v-5.01zm11.47-5.95c2.033 0 3.671 1.673 3.671 3.723 0 2.056-1.638 3.727-3.672 3.727h-.96v-7.45zm.373 10.707c3.806 0 6.901-3.132 6.901-6.984 0-3.868-3.063-6.995-6.87-6.995h-4.264v13.984h4.233zM31.849 5h-1.697a10.44 10.44 0 0 1 3.02 7.325c0 2.44-.864 4.771-2.396 6.622h1.618a11.34 11.34 0 0 0 2.135-6.622c0-2.7-.972-5.296-2.68-7.325M27.94 5h.438a11.4 11.4 0 0 1 2.668 7.325c0 2.396-.752 4.723-2.124 6.622h-1.617a10.43 10.43 0 0 0 2.386-6.622c0-2.748-1.094-5.394-3.01-7.325z",
			clipRule: "evenodd"
		})
	});
}
t.displayName = "IconAccessibilityArcomAudioDescription";
//#endregion
export { t as default };

//# sourceMappingURL=IconAccessibilityArcomAudioDescription.js.map